let suppressedTagsDictionary: number[] = [];
let currentSuppressedTagsEtag: string;

export function isTagSuppressed(tag: number): boolean {
  return suppressedTagsDictionary[tag] === 1;
}

export function updateSuppressedTagsFromSettings(
  suppressedTagsSetting: string,
  suppressedTagsEtag: string
) {
  if (
    currentSuppressedTagsEtag &&
    suppressedTagsEtag === currentSuppressedTagsEtag
  ) {
    // eTag is the same - no need to update
    return;
  }

  suppressedTagsDictionary = [];
  currentSuppressedTagsEtag = suppressedTagsEtag;

  if (!suppressedTagsSetting) {
    return;
  }

  const tags = suppressedTagsSetting.split(",");
  tags.forEach((tag) => {
    const iTag = parseInt(tag, 10);
    if (iTag) {
      suppressedTagsDictionary[iTag] = 1;
    }
  });
}
